import { render } from "./ProfileAccountTab.vue?vue&type=template&id=8b15d94e&ts=true"
import script from "./ProfileAccountTab.vue?vue&type=script&lang=ts"
export * from "./ProfileAccountTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__